import { connectFela } from '../../dependencies';
import MessageList from './MessageList';
import * as styles from './MessageList.styles';

export default connectFela(styles)(MessageList);
